import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import styles from './messages-list.module.scss'
import BupSpinner from '@BUP/components/Loading/Spinner'
import AlertComponent from '@BUP/components/Generics/Alert'
import MessageElement from '../message-element'
import { useDeleteNotifications } from '@BUP/hooks/Notifications/useDeleteNotifications'
import { isMessageNotified } from '@BUP/utils'
import { useGetMessagesList } from '@BUP/hooks/ModoBup/useGetMessagesList'

const MessagesList = ({
  title,
  titleDark,
  filterMessages,
  notifications,
  loadingNotifications
}) => {
  const i18n = useTranslation('translation', { keyPrefix: 'pages.modeBup.inbox' })
  const history = useHistory()
  const { deleteNotification } = useDeleteNotifications()
  const { loadingMessages, messagesList = [], errorMessagesList } = useGetMessagesList()

  const totalMessages = filterMessages(messagesList)

  const handleUrlToChatBox = async (message, messageCreator) => {
    const notificationIds = notifications
      ?.filter(
        notification =>
          notification.activity.comment.id === message.id ||
      notification.activity.comment.parent_comment_id === message.id
      )
      ?.map(notification => notification.id)

    if (notificationIds?.length) {
      await deleteNotification(notificationIds)
    }

    history.push({
      pathname: '/modebup/direct',
      mainMessage: message,
      messageCreator
    })
  }

  const handleUrlToChatBoxClosed = (message, messageCreator) => {
    history.push({
      pathname: '/modebup/direct',
      mainMessage: message,
      messageCreator
    })
  }

  if (loadingMessages || loadingNotifications) {
    return (
      <div className={styles.container}>
        <div
          className={styles.title_wrapper}
          style={titleDark ? { backgroundColor: '#767676', borderRadius: '8px' } : {}}
        >
          {title}
        </div>
        <div className={styles.content_wrapper}>
          <BupSpinner size='medium' />
        </div>
      </div>
    )
  }

  if (errorMessagesList) {
    return (
      <div className={styles.container}>
        <div
          className={styles.title_wrapper}
          style={titleDark ? { backgroundColor: '#767676', borderRadius: '8px' } : {}}
        >
          {title}
        </div>
        <div className={styles.content_wrapper}>
          <AlertComponent
            type='error'
            message={i18n.t('MessagesListComponent.error.text')}
          />
        </div>
      </div>
    )
  }

  if (totalMessages.length === 0) {
    return (
      <div className={styles.container}>
        <div
          className={styles.title_wrapper}
          style={titleDark ? { backgroundColor: '#767676', borderRadius: '8px' } : {}}
        >
          {title}
        </div>
        <div className={styles.content_wrapper}>
          <h3>{i18n.t('noMessageText')}</h3>
        </div>
      </div>
    )
  }

  const messagesWithNotification = totalMessages
    .map(message => ({
      ...message,
      hasNotification: isMessageNotified(message.id, notifications)
    }))
    .sort((a, b) => {
      if (a.hasNotification === b.hasNotification) return 0
      return a.hasNotification ? -1 : 1
    })

  return (
    <div className={styles.container}>
      <div
        className={styles.title_wrapper}
        style={titleDark ? { backgroundColor: '#767676', borderRadius: '8px' } : {}}
      >
        {title}
      </div>
      {messagesWithNotification.map(message => (
        <div
          key={`modebup-inbox-message-${message.id}`}
          onClick={() =>
            message.hasNotification
              ? handleUrlToChatBox(message)
              : handleUrlToChatBoxClosed(message)}
          data-testid='message-element'
        >
          <MessageElement
            message={message}
            checkNotification={message.hasNotification}
            isLoading={loadingMessages}
          />
        </div>
      ))}
    </div>
  )
}

export default MessagesList
